import React, { createContext, FC, PropsWithChildren, useContext, useTransition } from 'react';

type PageTransitionContextValue = {
    isPageTransitionPending: boolean;
    startPageTransition: (callback: () => void) => void;
};

const PageTransitionContext = createContext<PageTransitionContextValue>({
    isPageTransitionPending: false,
    startPageTransition: (callback) => {
        callback();
    }
});

export const PageTransitionProvider: FC<PropsWithChildren> = ({ children }) => {
    const [isPageTransitionPending, startTransition] = useTransition();

    const startPageTransition = (callback: () => void) => {
        startTransition(callback);
    };

    return <PageTransitionContext.Provider value={{ isPageTransitionPending, startPageTransition }}>{children}</PageTransitionContext.Provider>;
};

export const usePageTransition = () => useContext(PageTransitionContext);
